import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BackLink() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className="bg-gray-200 w-full text-black flex justify-start p-2 border-b border-gray-300"
    >
      <ChevronLeft size={16} /> <span className="text-xs">Back</span>
    </button>
  );
}
